module.exports = __webpack_public_path__ + "static/media/funda4.54bd31c0.jpg";